import { Dialog } from 'primereact/dialog';
import React from 'react';
import { CalculationMetricCard } from './CalculationMetricCard';
import './stackRankCalculation.scss';

interface StackRankCalculationProps {
    setDisplayModal?: (e: boolean) => void;
    displayModal: boolean;
    authorId: string;
    seletedRowData: any;
    inputMonth?: number;
    inputYear?: number;
    scorecardVersionID?: number | string;
}

export const StackRankCalculation = (props: StackRankCalculationProps) => {
    const {
        setDisplayModal,
        displayModal,
        authorId,
        seletedRowData,
        inputMonth,
        inputYear,
        scorecardVersionID,
    } = props;
    console.log(
        setDisplayModal,
        displayModal,
        authorId,
        seletedRowData,
        inputMonth,
        inputYear,
        scorecardVersionID
    );

    return (
        <Dialog
            header="Composite Score Calculation"
            visible={props?.displayModal}
            onHide={() => props.setDisplayModal && props.setDisplayModal(false)}
            style={{
                width: '66vw',
                height: '90vh',
            }}
            position="bottom"
            className="MetricDialog card shadow bg-body rounded mt-4 border-0 w-65"
            modal
            draggable={false}
            resizable={false}
            id="stackRankCalculationDialog"
        >
            <CalculationMetricCard
                seletedRowData={seletedRowData}
                inputMonth={inputMonth}
                inputYear={inputYear}
                scorecardVersionID={scorecardVersionID}
            />
        </Dialog>
    );
};
